<template>
  <div :class="['toolbar-item', { disabled }]">
    <router-link
      v-if="to.name"
      :class="{ active: $router.currentRoute.name === to.name, disabled }"
      :to="to"
      :event="disabled ? '' : 'click'"
    >
      <b-icon v-if="icon" :icon="icon" v-tooltip="{ content: tooltip || title, placement: 'bottom-center' }" />
      <template v-if="title">{{ title }}</template>
    </router-link>

    <a v-else-if="href" :target="target" :href="href">{{ title }}</a>

    <div v-else-if="$slots.default" tabindex="9999" :class="['header-menu', { disabled }]">
      <v-popover popoverInnerClass="toolbar-item-notice-dropdrown" @show="$emit('click', $event)">
        <b-icon v-if="icon" :icon="icon" />
        <span class="hidden-on-small-screens">{{ title }}</span>
        <template v-if="!disabled" slot="popover">
          <slot></slot>
        </template>
      </v-popover>
    </div>

    <a v-else-if="icon" href="#" @click="onIconClick">
      <b-icon v-if="icon" :icon="icon" v-tooltip="{ content: tooltip || title, placement: 'bottom-center' }" />
      <template v-if="title">{{ title }}</template>
    </a>
  </div>
</template>

<script>
/** @todo Refactor this component into three separate components. It has multiple purposes which is never good. */
export default {
  name: 'ToolbarItem',

  props: {
    title: {
      type: String,
    },
    icon: {
      type: String,
    },
    target: {
      type: String,
    },
    tooltip: {
      type: String,
    },
    href: {
      type: String,
    },
    to: {
      type: Object,
      default: function () {
        return { name: '' };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onIconClick(event) {
      event.preventDefault();
      if (!this.disabled) {
        this.$emit('click', event);
      }
    },
  },
};
</script>

<style scoped>
.toolbar-item {
  display: inline-block;
  font-size: 0.85rem;
  font-weight: 600;
}

.toolbar-item svg {
  font-size: 0.75rem;
}

.toolbar-item > a,
.toolbar-item > .header-menu {
  text-decoration: none;
  cursor: pointer;
  display: block;
  /** @todo Add margin to undo/redo icons too to make balanced padding on both sides of the item. */
  padding-left: 0.625rem;
}

.header-menu:hover {
  color: #0a58ca;
}

.toolbar-item > a:disabled,
.toolbar-item > a.disabled,
.toolbar-item > .header-menu.disabled {
  cursor: not-allowed;
  color: #ffffff6b;
}

.toolbar-item > a.router-link-active {
  background-color: #3a4652;
}
</style>

<style>
.toolbar-item-notice-dropdrown {
  background-color: #373e4d;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/toolbar/ToolbarItem.vue